export default {
  UPDATE_THEME: 'UPDATE_THEME'
};
